import React from 'react'
import style from '@aytm/app/swidget/base/questions/Ecommerce/Amazon/amazon.module.scss'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useSurveyLocale from '../../../modules/locale/useSurveyLocale'
import useSession from '../../../session/useSession'
import { getLocale } from '../functions'
interface IHeaderProps {
  results: number
  cartNumber: number
  searchCondition: string
  clearSelection: () => void
  openCart: () => void
  findability: boolean
  showArrow: boolean
}
const Header = ({
  results,
  cartNumber,
  searchCondition,
  clearSelection,
  openCart,
  findability,
  showArrow
}: IHeaderProps) => {
  const { t } = useSurveyLocale()
  const session = useSession()
  const localeData = getLocale(session.action?.data?.locale?.survey_locale)
  const cart = () => (
    <>
      <div className={style.cartContainer} aria-live="polite" aria-atomic="true">
        <span className={`${style.cartCounter} ${cartNumber > 99 ? style.compact : ''}`}>
          {cartNumber > 99 ? '99+' : cartNumber}
        </span>
        <span className={style.cartImage}></span>
      </div>
      <span id={'glow-ingress-line2'} className={style.line2}>
        {t('questions', 'ec', 'amazon', 'cart')}
      </span>
      {showArrow ? <span className={style.rightArrow} /> : null}
    </>
  )
  return (
    <>
      <header>
        <div id="navbar" className={style.navBar}>
          <div id="nav-belt" className={style.navBelt}>
            <div id="nav-left" className={style.navLeft}>
              <div id="nav-logo" className={style.navLogo} onClick={clearSelection}>
                <span className={style.navLogoBg} />
                <span className={style.navLogoText}>{`.${localeData.domain.toLowerCase()}`}</span>
              </div>
              <div id="nav-global-location-slot" className={style.location}>
                <div className={style.navSprite} />
                <div id={'glow-ingress-block'} className={style.ingressBlock}>
                  <span className={style.line1}>{t('questions', 'ec', 'amazon', 'deliverTo')}</span>
                  <EmptyLink>
                    <span className={style.line2}>{t('questions', 'ec', 'amazon', 'myAddress')}</span>
                  </EmptyLink>
                </div>
              </div>
            </div>
            <div id={'nav-fill'} className={style.navFill}>
              <div id="nav-search" className={style.navSearch} onClick={clearSelection}>
                <div className={style.navSearchScope}>
                  <span id="nav-search-label-id" className={style.navLabel}>
                    {t('questions', 'ec', 'amazon', 'all')}
                  </span>
                  <i className={style.navIcon} />
                </div>
                <div className={style.navSearchField}>
                  {searchCondition ? (
                    <button id="nav-search-label-id" className={`${style.navLabel}`}>
                      {searchCondition}
                    </button>
                  ) : null}
                </div>
                <div className={style.navSearchSubmit}>
                  <span className={style.navSearchSubmitText} />
                </div>
              </div>
            </div>
            <div id="nav-right" className={style.navRight}>
              <div className={style.navLang}>
                <span
                  className={style.navFlag}
                  style={{
                    backgroundImage: `url('https://purecatamphetamine.github.io/country-flag-icons/3x2/${localeData.country}.svg')`
                  }}
                />
                <EmptyLink>
                  <div>{t('questions', 'ec', 'amazon', 'lang')}</div>
                </EmptyLink>
                <EmptyLink>
                  <span className={style.navArrow} />
                </EmptyLink>
              </div>
              <div className={style.navLogin}>
                <EmptyLink>
                  <span className={style.line1}>
                    <span>{t('questions', 'ec', 'amazon', 'sign')}</span>
                  </span>
                </EmptyLink>
                <EmptyLink>
                  <div className={style.navLoginIcon}></div>
                </EmptyLink>
                <EmptyLink>
                  <span id={'glow-ingress-line3'} className={style.line3}>
                    {t('questions', 'ec', 'amazon', 'accounts')} <span className={style.navArrow} />
                  </span>
                </EmptyLink>
              </div>
              <div className={style.navReturn}>
                <span className={style.line1}>{t('questions', 'ec', 'amazon', 'returns')}</span>
                <EmptyLink>
                  <span className={style.line2}>{t('questions', 'ec', 'amazon', 'andOrders')}</span>
                </EmptyLink>
              </div>
              <button
                className={style.navCart}
                onClick={findability ? null : openCart}
                aria-label={`${t('questions', 'ec', 'amazon', 'cart')}: ${cartNumber}`}
              >
                {findability ? <EmptyLink>{cart()}</EmptyLink> : <>{cart()}</>}
              </button>
            </div>
          </div>
        </div>
        <div id="nav-main" className={style.navMain}>
          <div className={style.navMenu}>
            <div className={style.line}></div>
            <div className={style.line}></div>
            <div className={style.line}></div>
          </div>

          <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'all')}</span>
          </EmptyLink>
          {/* <EmptyLink>
            <span className={style.navLabel}>
              {t('questions', 'ec', 'amazon', 'medical')} <span className={style.navArrow} />
            </span>
          </EmptyLink> */}
          <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'best')}</span>
          </EmptyLink>
          <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'basics')}</span>
          </EmptyLink>
          {/* <EmptyLink>
            <span className={style.navLabel}>
              Prime
              <span className={style.navArrow} />
            </span>
          </EmptyLink> */}
          <EmptyLink>
            <span
              className={style.navLabel}
              dangerouslySetInnerHTML={{ __html: t('questions', 'ec', 'amazon', 'todayDeals') }}
            ></span>
          </EmptyLink>
          {/* <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'music')}</span>
          </EmptyLink> */}
          {/* <EmptyLink>
            <span className={style.navLabel}>
              {t('questions', 'ec', 'amazon', 'groceries')}
              <span className={style.navArrow} />
            </span>
          </EmptyLink> */}
          <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'customerService')}</span>
          </EmptyLink>
          {/* <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'amazonHome')}</span>
          </EmptyLink> */}
          {/* <EmptyLink>
            <span className={style.navLabel}>{t('questions', 'ec', 'amazon', 'registry')}</span>
          </EmptyLink> */}
        </div>
      </header>
      {searchCondition ? (
        <div className={style.navToolbar} onClick={clearSelection}>
          <div className={style.condition}>
            <span className={style.dumbText}>
              {t<(results: number) => string>('questions', 'ec', 'amazon', 'condition')(results)}&nbsp;
            </span>
            <span className={style.query}>
              <span className={style.short} dangerouslySetInnerHTML={{ __html: `&#34;${searchCondition}&#34;` }} />
            </span>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default Header
